import { atom, useAtomValue } from "jotai";
import { useLocation } from "react-router";
import { useSupabaseLoader } from "../../../../../server/supabase/hooks";
import { useIsActive } from "./use-is-active";

// This is only used while we are on the inbox page
export const inboxCountAtom = atom<number | null>(null);

/** The count is null while it loads, and when it fails, which `error` tells apart. */
export function useInboxCount(really: boolean): { count: number | null; error: Error | null } {
  const location = useLocation();

  const isActive = useIsActive();

  const inboxPageVal = useAtomValue(inboxCountAtom);

  const { data: count, error } = useSupabaseLoader(
    async ({ supabase, account_id }) => {
      if (!really) return 0;
      const { data, error: queryError } = await supabase
        .from("inbox_unread_count")
        .select("unread_conversation_count")
        .eq("id", account_id)
        .single();

      if (queryError) {
        console.error("Unable to fetch unread conversation count:", queryError);
        throw queryError;
      }

      return data.unread_conversation_count;
    },
    // We want to retrieve unread conversation count every time we navigate
    [location, really],
  );

  return {
    count: isActive("/inbox", true)() ? (inboxPageVal ?? count) : count,
    error,
  };
}
